import { render, staticRenderFns } from "./OpenPointsMachine.vue?vue&type=template&id=64cf1f78&scoped=true"
import script from "./OpenPointsMachine.vue?vue&type=script&lang=js"
export * from "./OpenPointsMachine.vue?vue&type=script&lang=js"
import style0 from "./OpenPointsMachine.vue?vue&type=style&index=0&id=64cf1f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cf1f78",
  null
  
)

export default component.exports